/**
 * @file 결재 양식 관리 API (GLOBAL_ADMIN 전용)
 *
 * 저장과 발행이 나뉘어 있다. 저장은 언제든 되고 검증하지 않는다 — 칸을 하나 지우고 다음 칸을
 * 추가하는 중간 상태는 항상 불완전하기 때문이다. 검증은 발행에서만 걸린다.
 *
 * 저장하면 초안 버전이 생기고, 발행하면 그 버전이 활성화된다. 이미 상신된 문서는 자기 버전을
 * 그대로 쓰므로 3단계로 진행 중인 문서를 2단계로 줄여도 그 문서는 3단계로 끝난다.
 */

import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const ROOT = `${API_BASE}/approval/admin/forms`;

export const formAdminApi = {
    /** 양식 목록 — 비활성 포함. hasDraft 로 «초안 있음» 배지를 단다. */
    list:        ()                    => api.get(ROOT),

    /** 슬롯·연동 사전 — 편집 화면의 선택지. */
    dictionary:  ()                    => api.get(`${ROOT}/dictionary`),

    /** 입력칸 정의 — 초안이 있으면 초안, 없으면 최신 발행본. */
    schema:      (templateId)          => api.get(`${ROOT}/${templateId}/schema`),
    saveSchema:  (templateId, fields)  => api.put(`${ROOT}/${templateId}/schema`, fields),

    /** 연동·결재선·열람자. 입력칸과 같은 초안에 쌓인다. */
    rules:       (templateId)          => api.get(`${ROOT}/${templateId}/rules`),
    saveRules:   (templateId, rules)   => api.put(`${ROOT}/${templateId}/rules`, rules),

    /** 발행 전 점검 — 막는 것·확인할 것·승인 시 일어날 일·슬롯 배치. */
    check:       (versionId)           => api.get(`${ROOT}/versions/${versionId}/check`),

    /** 자금수지 미리보기 — 슬롯 오배치를 눈으로 잡는 장치. */
    preview:     (versionId)           => api.get(`${ROOT}/versions/${versionId}/preview`),

    publish:     (versionId)           => api.post(`${ROOT}/versions/${versionId}/publish`),

    setActive:   (templateId, active)  => api.patch(`${ROOT}/${templateId}/active?active=${active}`),
    setNotice:   (templateId, notice)  => api.put(`${ROOT}/${templateId}/notice`, { notice }),
};
